import { db } from './index';

export class DatabaseCleanup {
  async clearAll() {
    try {
      if (!db.isOpen()) {
        console.log('Banco já está fechado');
        return;
      }

      const tableNames = db.tables.map(table => table.name);
      const clearPromises = tableNames.map(name => db[name].clear());

      await Promise.all(clearPromises);
      console.log('Todos os dados do Dexie limpos');
    } catch (error) {
      console.error('Erro ao limpar banco:', error);
      throw error;
    }
  }
}

export const databaseCleanup = new DatabaseCleanup();
